import React from 'react';

import LottieView from '../lottie-view';

import loadingAnimation from './json/loading.json';

export const LoadingAnimation = ({ onComplete }: { onComplete?: () => void }) => (
  <LottieView
    testID="reset-location-loading-animation"
    source={loadingAnimation}
    autoPlay
    colorFilters={[
      {
        keypath: 'Dots',
        color: Styles.color.black,
      },
    ]}
    onAnimationFinish={() => onComplete?.()}
    style={{ width: 50, height: 50 }}
  />
);
